import { Analytics } from '@vercel/analytics/react';
import './App.css';
import { Terminal } from './components/Terminal';

function App() {
  return (
    <>
      <Terminal />
      <Analytics />
    </>
  );
}

export default App;
